import { render, staticRenderFns } from "./EditImg.vue?vue&type=template&id=4be0d808&scoped=true&"
import script from "./EditImg.vue?vue&type=script&lang=js&"
export * from "./EditImg.vue?vue&type=script&lang=js&"
import style0 from "./EditImg.vue?vue&type=style&index=0&id=4be0d808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be0d808",
  null
  
)

export default component.exports